import { DataFilter, ListStore } from "./listStore";

export function listStoreInFilter<T, U extends string | number>(filterName: string, props: (keyof T)[],
    store: Pick<ListStore<T>, "dataFilters" | "setFilterData" | "fetch">, allValues: U[]) {
    const filter: DataFilter<T> | null = store.dataFilters[filterName];
    const filterValue = (filter?.value as (string | number)[] || []);
    const areAllChecked = filterValue.length === allValues.length;

    function toggle(value: U) {
        let f = filter;
        let v = filterValue;
        if (v.indexOf(value) >= 0) {
            v = v.filter(p => p !== value);
        } else {
            v = v.concat(value);
        }
        f = v.length === 0 ? null : {
            props,
            operator: "In",
            value: v,
        };
        store.setFilterData(filterName, f);
        store.fetch({ updateFetchFilterData: true, forceFetch: false });
    }

    function toggleAll() {
        if (areAllChecked) {
            store.setFilterData("type", null);
        } else {
            store.setFilterData("type", {
                props,
                operator: "In",
                value: allValues,
            });
        }
        store.fetch({ updateFetchFilterData: true, forceFetch: false });
    }

    function isChecked(value: U) {
        return filterValue.indexOf(value) >= 0;
    }

    return {
        toggle,
        toggleAll,
        isChecked,
        areAllChecked,
    };
}